module.exports = __webpack_public_path__ + "img/success_register.35315895.png";